import styled from "@emotion/styled";
import * as colors from "src/styles/constants/colors";

export const TemplatesContainer = styled.div`
  grid-column: 2 / span 1;
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100%;
  padding: 24px;
  background: ${colors.brightLight};
  overflow: hidden;
`;
